import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaAction, ISchemaChild, ISchemaFilter, ISchemaProperty } from "../Schema";
import { IsBetweenInclusive, IsValidYear, NotEmptyString } from "../../../../Validation/Validation";
import { EntityNames } from "../../../../enums/EntityNames";
import { EntityViewTypes } from "../../../../enums/EntityViewTypes";
import { ActionTypes } from "../../../../enums/ActionTypes";
import { ActionStyles } from "../../../../enums/ActionStyles";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import editIcon from "../../../../assets/icons/icon-pen-white.svg"
import SidePanelRanges from "../../layout/SidePanel/layouts/SidePanelRanges";

export const RangesSchema: ISchema = {
    displayName: "Range",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelRanges data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'rangeStart_Original',
            displayName: 'Range start',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "Start case number cannot be empty",
        } as ISchemaProperty,
        {
            name: 'rangeEnd_Original',
            displayName: 'Range end',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: NotEmptyString as Function,
            validationError: "End case number cannot be empty",
        } as ISchemaProperty,
        {
            name: 'caseMaterialTypeId',
            displayName: 'Type',
            type: PropertyTypes.PackingBoxType,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            entityName: EntityNames.caseMaterialTypes,
            rememberLastFormValue: true
        } as ISchemaProperty,
        {
            name: 'displayName',
            displayName: '',
            type: PropertyTypes.string,
            descriptor: true,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'year',
            displayName: 'Year(s)',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'yearStart',
            displayName: 'Year start',
            type: PropertyTypes.year,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: IsValidYear as Function,
            validationError: "Please enter valid year",
        } as ISchemaProperty,
        {
            name: 'yearEnd',
            displayName: 'Year end',
            type: PropertyTypes.year,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            validateRule: IsValidYear as Function,
            validationError: "Please enter valid year",
        } as ISchemaProperty,
        {
            name: 'type',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
        } as ISchemaProperty,
        {
            name: 'accountName',
            displayName: 'Account',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'accountPrefix',
            displayName: '',
            type: PropertyTypes.accountPrefix,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            renderBasedOnParentData: (values, isCreate) => {
                if (!values) {
                    return false;
                }
                return true;
            }
        } as ISchemaProperty,
        {
            name: 'prefix',
            displayName: 'Prefix',
            type: PropertyTypes.string,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false
        } as ISchemaProperty,
        {
            name: 'notes',
            displayName: 'Notes',
            type: PropertyTypes.textArea,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: false,
            autocomplete: "on"
        } as ISchemaProperty,
        {
            name: 'currentLocation',
            displayName: 'Current Location',
            type: PropertyTypes.breadcrumb,
            key: false,
            showInList: false,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
    ],

    children: [
        { entityName: EntityNames.cases, displayName: "Cases", viewType: EntityViewTypes.list, enableFilters: true } as ISchemaChild,
        { entityName: EntityNames.specimens, displayName: "Specimens", viewType: EntityViewTypes.list, enableFilters: true } as ISchemaChild,
        { entityName: EntityNames.audits, displayName: "Audit Trail", cantView: true, viewType: EntityViewTypes.list } as ISchemaChild
    ],

    primaryFilter: {
        PropertyName: "Code",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.code,
        placeHolder: "Enter a case number"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "AccountId",
            entityName: EntityNames.accounts,
            displayName: "Account",
            type: FilterTypes.select,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid,
            showInTab: true
        } as ISchemaFilter,
        {
            PropertyName: "Year",
            displayName: "Year",
            type: FilterTypes.year,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.year,
            showInTab: true
        } as ISchemaFilter,
    ],

    sidePanelActions: [
        { text: "Edit Details", action: ActionTypes.edit, style: ActionStyles.primary, icon: editIcon } as ISchemaAction,
    ]
}
